var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6 55L54.1 42.5C55.0333 41.9 55.5 41.0667 55.5 40C55.5 38.9333 55.0333 38.1 54.1 37.5L34.6 25C33.6 24.3333 32.5833 24.2833 31.55 24.85C30.5167 25.4167 30 26.3 30 27.5V52.5C30 53.7 30.5167 54.5833 31.55 55.15C32.5833 55.7167 33.6 55.6667 34.6 55ZM40 80C34.4667 80 29.2667 78.95 24.4 76.85C19.5333 74.75 15.3 71.9 11.7 68.3C8.1 64.7 5.25 60.4667 3.15 55.6C1.05 50.7333 0 45.5333 0 40C0 34.4667 1.05 29.2667 3.15 24.4C5.25 19.5333 8.1 15.3 11.7 11.7C15.3 8.1 19.5333 5.25 24.4 3.15C29.2667 1.05 34.4667 0 40 0C45.5333 0 50.7333 1.05 55.6 3.15C60.4667 5.25 64.7 8.1 68.3 11.7C71.9 15.3 74.75 19.5333 76.85 24.4C78.95 29.2667 80 34.4667 80 40C80 45.5333 78.95 50.7333 76.85 55.6C74.75 60.4667 71.9 64.7 68.3 68.3C64.7 71.9 60.4667 74.75 55.6 76.85C50.7333 78.95 45.5333 80 40 80Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.344870a9a20dd59f6df10d4c8c115469.svg";
export { ForwardRef as ReactComponent };